<template>
  <v-container grid-list-xl>
    <v-layout wrap>
      <v-card>
        <v-card-title>
          {{ "Meet Report" }}
        </v-card-title>
        <v-spacer></v-spacer>
        <v-layout row wrap>
          <v-flex xs2 lg2>
            <v-autocomplete
              v-model="athleteId"
              :rules="athleteRules"
              required
              :hint="`${athleteId}`"
              label="Select Athlete Name"
              :items="getAthletes()"
              item-value="athleteId"
              :item-text="text"
            >
            </v-autocomplete>
          </v-flex>
        </v-layout>
        <v-flex>
          <athleteResults />
        </v-flex>
        <v-flex>
          <athleteRanks />
        </v-flex>
      </v-card>
    </v-layout>
  </v-container>
</template>
<script>
//import athleteAttendance from "./AthleteAttendance.vue";
import athleteResults from "./AthleteResults.vue";
import athleteRanks from "./AthleteRanks.vue";
//import clubGroups from "./GroupList.vue";
//import athleteList from "./AthleteList.vue";
import { mapGetters } from "vuex";

export default {
  components: {
    //athleteAttendance,
    athleteResults,
    athleteRanks
    //clubGroups
    //athleteList
    // SheetFooter: {
    //   functional: true,

    //   render(h, { children }) {
    //     return h(
    //       "v-sheet",
    //       {
    //         staticClass: "mt-auto align-center justify-center d-flex",
    //         props: {
    //           color: "rgba(0, 0, 0, .36)",
    //           dark: true,
    //           height: 50
    //         }
    //       },
    //       children
    //     );
    //   }
    // }
  },
  data() {
    return {
      tabs: 0,
      isFormValid: true,
      status: "active",
      search: "",
      athleteId: ""
    };
  },
  created() {
    this.handleGetAthleteResults();

    //this.handleGetAthleteList();
  },
  computed: {
    ...mapGetters(["loading", "athleteList", "athleteResults"])
  },
  methods: {
    handleGetAthleteResults() {
      //reach out of Vuex store, fire action that gets posts for carousel
      if (
        this.athleteResults === undefined ||
        this.athleteResults.length == 0
      ) {
        this.$store.dispatch("allResults", {
          clubId: this.$route.params.club
        });
      }
    },
    getAthletes: function() {
      return Array.from(
        new Set(this.athleteResults.edges.map(item => item.node.athleteId))
      ).map(athleteId => {
        return {
          athleteId: athleteId,
          firstName: this.athleteResults.edges.find(
            item => item.node.athleteId === athleteId
          ).node.athlete.firstName,
          lastName: this.athleteResults.edges.find(
            item => item.node.athleteId === athleteId
          ).node.athlete.lastName
        };
      });
    }
  },
  mounted() {}
};
</script>
